import { Text } from "react-native-paper";
import { useAppTheme } from "../../../../../useAppTheme";
import Box from "../../../../Box";
import { useScoreToneColors } from "./reorder-paragraph-utils";
import { formatPoints } from "./review-helpers";

export const PAIR_SEPARATOR_HEIGHT = 32;

export const PairSeparator = ({
	credited,
	pointsPerPair,
}: {
	credited?: boolean;
	pointsPerPair: number;
}) => {
	const theme = useAppTheme();
	const scoreTones = useScoreToneColors();
	const tone = credited === undefined ? null : credited ? "success" : "error";
	const lineColor = tone
		? scoreTones[tone].accent
		: theme.colors.outlineVariant;

	return (
		<Box
			height={PAIR_SEPARATOR_HEIGHT}
			alignItems="center"
			justifyContent="center"
		>
			<Box
				position="absolute"
				top={0}
				bottom={0}
				width={0}
				borderLeftWidth={1}
				borderStyle="dashed"
				borderColor={lineColor}
			/>
			{tone ? (
				<Box
					position="absolute"
					paddingHorizontal={8}
					paddingVertical={2}
					borderRadius={theme.roundness * 2}
					minWidth={32}
					alignItems="center"
					backgroundColor={scoreTones[tone].background}
					style={{ zIndex: 1 }}
				>
					<Text
						variant="labelSmall"
						style={{ color: scoreTones[tone].foreground }}
					>
						{credited ? `+${formatPoints(pointsPerPair)}` : "0"}
					</Text>
				</Box>
			) : null}
		</Box>
	);
};
